<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Solicitações de Renovação</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Prospects</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Prospect</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0">Solicitante</th>
                    <th scope="col" class="border-0">Data de expiração</th>
                    <th scope="col" class="border-0">Data da solicitação</th>
                    <th scope="col" class="border-0">Data da nova expiração</th>
                    <th scope="col" class="border-0">Dias solicitados</th>
                    <th scope="col" class="border-0">Nº de solicitações</th>
                    <th
                      scope="col"
                      class="border-0"
                      v-if="$isAuthorize('ProspectHistory', 'Update')"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(prospectHistory, index) in prospectHistories"
                    :key="index"
                  >
                    <td></td>
                    <td class="text-left">
                      {{ prospectHistory.Prospect.Name | substring(50) }}
                    </td>
                    <td>
                      <div>
                        {{
                          prospectHistory.ProspectHistoryStatus.Name
                            | split(" ")
                        }}
                      </div>
                      <span
                        class="td-span-style"
                        v-if="
                          prospectHistory.UserInternal.Name != null &&
                          prospectHistory.UserInternal.Name != undefined &&
                          prospectHistory.UserInternal.Name != ''
                        "
                      >
                        POR
                        {{
                          prospectHistory.UserInternal.Name | split(" ")
                        }}</span
                      >
                    </td>
                    <td>
                      <div>
                        {{ prospectHistory.UserPartner.Name | split(" ") }}
                      </div>
                      <span class="td-span-style"
                        >PARCEIRO
                        {{
                          prospectHistory.UserPartner.Partner.Name
                            | upper
                            | split(" ")
                        }}</span
                      >
                    </td>
                    <td>{{ prospectHistory.ExpirationDate | date }}</td>
                    <td>{{ prospectHistory.CreatedDate | date }}</td>
                    <td>{{ prospectHistory.SolicitationDate | date }}</td>
                    <td>{{ prospectHistory.DaysToExpiration }}</td>
                    <td>{{ prospectHistory.RequestNumber }}</td>
                    <td v-if="$isAuthorize('ProspectHistory', 'Update')">
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="
                              loadingApprove ||
                              prospectHistory.ProspectHistoryStatus.Code != '1'
                                ? 'disabled'
                                : ''
                            "
                            v-on:click.stop="
                              ConfirmUpdateProspectHistory($event, index, true)
                            "
                          >
                            <template v-if="loadingApprove">
                              <loader
                                :small="true"
                                :isLoading="loadingApprove"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-check mr-2"></i>
                              Aprovar
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="
                              loadingDisapprove ||
                              prospectHistory.ProspectHistoryStatus.Code != '1'
                                ? 'disabled'
                                : ''
                            "
                            v-on:click.stop="
                              ConfirmUpdateProspectHistory($event, index, false)
                            "
                          >
                            <template v-if="loadingDisapprove">
                              <loader
                                :small="true"
                                :isLoading="loadingDisapprove"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-times mr-2"></i>
                              Reprovar
                            </template>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      prospectHistories == null ||
                      prospectHistories == undefined ||
                      prospectHistories.length == 0
                    "
                  >
                    <td colspan="9">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeProspectHistoryStatus" :value="null">
            <option :value="null" selected>Status</option>
            <option
              v-for="status in prospectHistoryStatus"
              v-bind:key="status.Code"
              v-bind:value="status.Code"
            >
              {{ status.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdUserPartner" :value="null">
            <option :value="null" selected>Solicitante</option>
            <option
              v-for="userPartner in userPartners"
              v-bind:key="userPartner.Id"
              v-bind:value="userPartner.Id"
            >
              {{ userPartner.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdPartner" :value="null">
            <option :value="null" selected>Parceiro</option>
            <option
              v-for="partner in partners"
              v-bind:key="partner.Id"
              v-bind:value="partner.Id"
            >
              {{ partner.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdUserInternal" :value="null">
            <option :value="null" selected>Usuário interno</option>
            <option
              v-for="userInternal in userInternals"
              v-bind:key="userInternal.Id"
              v-bind:value="userInternal.Id"
            >
              {{ userInternal.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="12" class="form-group">
          <input
            :placeholder="labelNameProspect"
            type="text"
            class="form-control"
            v-model="filter.NameProspect"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "prospect-histories",
  data: function () {
    return {
      countFilter: 0,
      filter: {
        CodeProspectHistoryStatus: this.listPending ? "1" : null,
        NameProspect: null,
        IdUserPartner: null,
        IdPartner: null,
        IdUserInternal: null,
      },
      listPending: false,
      loadingList: false,
      loadingApprove: false,
      loadingDisapprove: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      prospectHistoryStatus: [],
      prospectHistories: [],
      userPartners: [],
      partners: [],
      userInternals: [],
      labelNameProspect: "Prospect",
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListProspectHistory();
    },
    "pagination.RowsPerPage": function () {
      this.ListProspectHistory();
    },
  },
  mounted() {
    if (this.$route.query.listPending == "true") {
      this.listPending = true;
      this.filter.CodeProspectHistoryStatus = "1";
    }
    this.ListProspectHistory();
    this.ListProspectHistoryStatus();
    this.ListUserPartner();
    this.ListPartner();
    this.ListUserInternal();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListProspectHistory();
    },
    ResetFilter: function () {
      this.filter = {
        CodeProspectHistoryStatus: this.listPending ? "1" : null,
        NameProspect: null,
        IdUserPartner: null,
        IdPartner: null,
        IdUserInternal: null,
      };
      this.ListProspectHistory();
    },
    ListProspectHistoryStatus: function () {
      this.$store
        .dispatch("ListProspectHistoryStatus")
        .then((response) => {
          this.prospectHistoryStatus = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de status",
            error
          );
        });
    },
    ListUserPartner: function () {
      this.$store
        .dispatch("ListUserPartner", { params: {} })
        .then((response) => {
          this.userPartners = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de usuários parceiros",
            error
          );
        });
    },
    ListPartner: function () {
      let data = { OrderByColumn: "Name" };
      this.$store
        .dispatch("ListPartner", { params: data })
        .then((response) => {
          this.partners = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de parceiros",
            error
          );
        });
    },
    ListUserInternal: function () {
      this.$store
        .dispatch("ListUserInternal", { params: {} })
        .then((response) => {
          this.userInternals = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de usuários internos",
            error
          );
        });
    },
    ListProspectHistory: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.CodeProspectHistoryStatus)) this.countFilter++;
      if (hasValue(this.filter.NameProspect)) this.countFilter++;
      if (hasValue(this.filter.IdUserPartner)) this.countFilter++;
      if (hasValue(this.filter.IdPartner)) this.countFilter++;
      if (hasValue(this.filter.IdUserInternal)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.ProspectHistoryStatus.Code": this.filter
            .CodeProspectHistoryStatus,
          "Object.Prospect.Name": this.filter.NameProspect,
          "Object.UserPartner.Id": this.filter.IdUserPartner,
          "Object.UserPartner.Partner.Id": this.filter.IdPartner,
          "Object.UserInternal.Id": this.filter.IdUserInternal,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListProspectHistory", { params: data })
        .then(
          (response) => {
            this.prospectHistories = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível listar as solicitações",
              "danger",
              "Solicitações",
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    ConfirmUpdateProspectHistory: function (e, i, approve) {
      e.preventDefault();
      let prospectHistory = this.prospectHistories[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja ${
          approve ? "aprovar" : "reprovar"
        } esta solicitação?`,
        "Confirmar",
        this.UpdateProspectHistory,
        i,
        approve
      );
    },
    UpdateProspectHistory: function (i, approve) {
      let codeProspectHistoryStatus = "";
      let prospectHistory = this.prospectHistories[i];
      let userInternal = this.$getUserInternal();

      if (approve) {
        this.loadingApprove = true;
        codeProspectHistoryStatus = "2";
      } else {
        this.loadingDisapprove = true;
        codeProspectHistoryStatus = "3";
      }

      let infoProspectHistory = {
        Id: prospectHistory.Id,
        ProspectHistoryStatus: {
          Code: codeProspectHistoryStatus,
        },
        Prospect: {
          Name: prospectHistory.Prospect.Name,
        },
        UserPartner: {
          Name: prospectHistory.UserPartner.Name,
          Email: prospectHistory.UserPartner.Email,
        },
        UserInternal: userInternal,
      };

      this.$store
        .dispatch("UpdateProspectHistory", infoProspectHistory)
        .then(() => {
          this.$makeToast(
            "Sua resposta foi processada com sucesso",
            "success",
            "Solicitações"
          );
          this.ListProspectHistory();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao processar sua resposta",
            error
          );
        })
        .finally(() => {
          if (approve) this.loadingApprove = false;
          else this.loadingDisapprove = false;
        });
    },
  },
};
</script>

<style scoped>
.td-span-style {
  font-size: 8pt;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/prospectHistories.vue